/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Error_Line_1Inputs */

const fr_vehicle_action_edit_error_line_1 = /** @type {(inputs: Vehicle_Action_Edit_Error_Line_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'enregistrement des informations.`)
};

const en_vehicle_action_edit_error_line_1 = /** @type {(inputs: Vehicle_Action_Edit_Error_Line_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while saving the information.`)
};

/**
* | output |
* | --- |
* | "An error occurred while saving the information." |
*
* @param {Vehicle_Action_Edit_Error_Line_1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_error_line_1 = /** @type {((inputs?: Vehicle_Action_Edit_Error_Line_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Error_Line_1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_error_line_1(inputs)
	return en_vehicle_action_edit_error_line_1(inputs)
});